import React, { useState } from 'react'
import { Card, Collapse } from 'react-bootstrap'
import ReactMarkdown from 'react-markdown'
import { Button } from '../ButtonElement';

export default function Blog({ blog }) {
  const [open, setOpen] = useState(false)

  return (
    <Card className="mb-3">
      <Card.Body>
        <div className="d-flex justify-content-between">
          <div>
            <Card.Title>
              {blog.title} - <span className="text-muted font-weight-light">{blog.author}</span>
            </Card.Title>
            {/* <Card.Subtitle className="text-muted mb-2">
              {new Date(blog.created_at).toLocaleDateString()}
            </Card.Subtitle> 
            <Badge variant="secondary" className="mr-2">{blog.type}</Badge>
            <Badge variant="secondary">{blog.location}</Badge> */}
            {/* <div style={{ wordBreak: 'break-all' }}>
              <ReactMarkdown source={blog.how_to_apply} />
            </div> */}
          </div>
          {/* <img className="d-none d-md-block" height="50" alt={blog.company} src={blog.company_logo} /> */}
          {/* <div>{blog.author}</div> */}
        </div>
        <Card.Text>
          <Button
            onClick={() => setOpen(prevOpen => !prevOpen)}
            variant="primary"
          >
            {open ? 'Hide Details' : 'View Details'}
          </Button>
        </Card.Text>
        <Collapse in={open}>
          <div className="mt-4">
            <ReactMarkdown source={blog.body} />
          </div>
        </Collapse>
      </Card.Body>
    </Card>
  )
}
